<template>
    <div class="zy-box occupation-box school-box">
        <Breadcrumb></Breadcrumb>
        <el-row class="zy-school" type="flex" justify="space-between">
        <el-col :span="16">
            <el-row class="occupation-box-content">
                <div class="search-img header-search">
                    <el-select v-model="searchJob" clearable filterable remote :remote-method="getSearchJobListHandler" :loading="loading" reserve-keyword placeholder="查职业"> 
                        <el-option
                            v-for="item in optionsJob"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <img src="../../assets/images/sousuo.png" alt="搜索" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="!isShowSearch" @click="searchJobListHandler()">
                    <img src="../../assets/images/sousuo-diff.png" alt="搜索" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="isShowSearch" @click="searchJobListHandler()">
                    <!-- <el-input
                    placeholder="查职业"
                    v-model="searchJob"
                    @keyup.enter.native="searchJobListHandler()"
                    >
                    <template slot="append">
                        <img
                        src="../../assets/images/sousuo.png"
                        alt="搜索"
                        @click="searchJobListHandler()"
                        @mouseenter="isShowSearch = !isShowSearch"
                        @mouseleave="isShowSearch = !isShowSearch"
                        v-if="!isShowSearch"
                        />
                        <img
                        src="../../assets/images/sousuo-diff.png"
                        alt="搜索"
                        @click="searchJobListHandler()"
                        @mouseenter="isShowSearch = !isShowSearch"
                        @mouseleave="isShowSearch = !isShowSearch"
                        v-if="isShowSearch"
                        />
                    </template>
                    </el-input> -->
                </div>
                <div class="province-list">
                    <div class="title-box">职业类型：</div>
                    <ContentLoader
                    :base-url="$route.fullPath"
                    height="56"
                    width="670"
                    viewBox="0 0 670 56"
                    v-if="typeList.length == 1"
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    >
                    <rect x="10" y="0" width="670" height="20" />
                    <rect x="10" y="30" width="670" height="20" />
                    </ContentLoader>
                    <div class="province-name" v-else>
                    <a
                        v-for="(item, index) in typeList"
                        :key="index"
                        :class="activeTag == index ? 'active-tag' : ''"
                        @click="activeTagHandler(index)" :href="'#job_' + index"
                        >{{ item.job_name }}</a
                    >
                    </div>
                </div>
                <div v-if="!searchSchoolStatus1">
                    <ContentLoader
                    :base-url="$route.fullPath"
                    height="150"
                    width="670"
                    viewBox="0 0 670 200"
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    v-for="item in 2"
                    :key="item"
                    >
                    <rect x="0" y="20" width="70" height="25" />
                    <rect x="20" y="60" width="100" height="23" />
                    <rect x="20" y="100" width="150" height="20" />
                    </ContentLoader>
                </div>
                <el-row class="collapse-box" v-else-if="searchSchoolStatus">
                    <div
                    class="collapse-list"
                    v-for="(item, index) in jobList"
                    :key="index" :id="'job_' + index"
                    >
                        <h2>{{ item.job_name }}</h2>
                        <div v-for="(item1, index1) in item.children" :key="index1">
                            <h4>{{ item1.job_name }}</h4>
                            <el-row class="occupation-list">
                                <el-col :span="8" class="zytb-school-name" v-for="(item2, index2) in item1.children" :key="index2" @click.native="clickJobDetailHandler(item2.job_code)">
                                    {{ item2.job_name }}
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <!-- <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="jobTotal"
                    :page-size="20"
                    @current-change="getJobListHandler"
                    :current-page.sync="currentPage"
                    v-if="jobTotal > 0"
                    >
                    </el-pagination> -->
                </el-row>
                <el-row class="school-detail-nav fixed-top" v-if="scrollTag"> 
                    <div class="el-tabs__header is-top">
                        <div class="el-tabs__nav-wrap is-top">
                            <div class="el-tabs__nav-scroll">
                                <div role="tablist" class="el-tabs__nav is-top">
                                    <a v-for="(item, index) in typeList" :key="index" class="el-tabs__item is-top" :class="activeTag == index ? 'is-active' : ''" @click="activeTagHandler(index)" :href="'#job_' + index">{{ item.job_name }}<span class="el-tabs__active-bar is-top"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-row>
                <div v-if="!searchSchoolStatus" class="no-data-box">
                    <img src="../../assets/images/null.png" alt="没有数据" />
                    <p>没有查询到专业</p>
                </div>
            </el-row>
        </el-col>
        <el-col :span="8" class="zyb-box">
            <OccupationRank></OccupationRank>
            <News></News>
        </el-col>
        </el-row>
    </div>
</template>

<script>
import { getJobList, getJobCategory } from "@/api/occupation";
import { getSearchJobList } from "@/api/zhiyuan";
import { ContentLoader } from "vue-content-loader";
import { mapState } from "vuex";
export default {
    components: {
        ContentLoader,
    },
    data() {
        return {
            isShowSearch: false,
            typeList: [],
            activeTag: 0,
            searchJob: "",
            jobList: [],
            searchSchoolStatus: true,
            searchSchoolStatus1: false,
            // optionsJob: [],
            optionsJob: [{
                value: 0,
                code: "02090500",
                label: "幼儿教师"
            },{
                value: 1,
                code: "02060300",
                label: "会计人员"
            },{
                value: 2,
                code: "02050102",
                label: "外科医师"
            },{
                value: 3,
                code: "02040101",
                label: "飞行驾驶员"
            },{
                value: 4,
                code: "02080300",
                label: "律师"
            }],
            loading: false,
            selectJob: '',
            scrollTag: false,
            has_code: 0
        };
    },
    computed: {
        ...mapState({
            requestCount: (state) => state.user.requestCount,
            function_code: state => state.user.function_code
        }),
    },
    watch: {
        requestCount(newVal) {
            // this.searchSchoolStatus1 = false;
            if (newVal > 0) {
                this.searchSchoolStatus1 = false;
            } else {
                this.searchSchoolStatus1 = true;
            }
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00025'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    created() {
        this.$store.commit("user/ADDCOUNT", 0);
        this.getAlljobHandler();
        this.getJobListHandler("1");
    },
    activated() {
        window.addEventListener('scroll', this.onScroll, true)
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00025'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
    },
    deactivated() {
        window.removeEventListener('scroll', this.onScroll, true)
    },
    methods: {
        clickHandler(special_id) {
            this.$router.push({
                path: "/occupationDetail",
                query: {
                special_id: special_id,
                },
            });
        },
        activeTagHandler(index) {
            this.activeTag = index;
        },
        getAlljobHandler() {
            getJobCategory().then((res) => {
                this.typeList.push(...res.data);
            });
        },
        searchJobListHandler() {
            this.getJobListHandler();
        },
        getJobListHandler() {
            let job_name = '';
            if(this.searchJob !== '') {
                job_name = this.optionsJob[this.searchJob].label;
            }
            getJobList(job_name,'').then((res) => {
                console.log(res,'data')
                this.jobTotal = res.data.list.total;
                if (res.data.count == 0) {
                    this.searchSchoolStatus = false;
                    return;
                }
                this.searchSchoolStatus = true;
                let data = res.data.list;
                this.jobList = data;
            });
        },
        getSearchJobListHandler(query) {
            if(query == '') {
                return
            }
            this.selectJob = query;
            this.loading = true;
            getSearchJobList(query).then(res => {
                this.loading = false;
                let list = res.data.map((item,index) => {
                    return { value: `${index}`, label: `${item.job_name}` };
                });
                this.optionsJob = list;
            })
        },
        // 滚动监听器
        onScroll() {
            let scrollTop = document.getElementById('app').scrollTop
            if (scrollTop > 400) {
                this.scrollTag = true;
            } else {
                this.scrollTag = false;
            }
            const navContents = document.querySelectorAll('.collapse-list')
            const offsetTopArr = []
            navContents.forEach(item => {
                offsetTopArr.push(item.offsetTop - 100)
            })
            let navIndex = 0
            for (let n = 0; n < offsetTopArr.length; n++) {
                if (scrollTop >= offsetTopArr[n]) {
                navIndex = n
                }
            }
            this.activeTag = navIndex
        },
        clickJobDetailHandler(job_code) {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            this.$router.push({
				path:'/occupationDetail',
                query: {
                    job_code: job_code
                }
			})
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.zy-img {
    @include gwidth;
    margin-top: 10px;
}
.zy-school {
    @include gwidth;
    .el-col-7 {
        width: 32.5%;
    }
    .el-col-16 {
        position: relative;
        padding-right: 16px;
        margin-top: 24px;
    }
    .occupation-box-content {
        min-height: 500px;
        background: #ffffff;
        border-radius: 10px;
        padding: 24px 24px 24px 24px;
        box-sizing: border-box;
    }
}
.rank-box {
    border: none;
    background: #f5f7fa;
    box-shadow: none !important;
    margin-top: 24px;
}
.province-list {
    @include gflex;
    font-size: 0;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
    .title-box {
        width: 78px;
        font-size: 14px;
        text-align: right;
        color: #909399;
        margin-top: 3px;
    }
    a {
        display: inline-block;
        margin-left: 20px;
        font-size: 14px;
        color: #5e6166;
        cursor: pointer;
        text-align: center;
        margin-bottom: 10px;
        padding: 3px 5px;
        text-decoration:none;
    }
    a:hover {
        color: $common-color;
    }
    .active-tag {
        color: #ffffff !important;
        background: $common-color;
        border-radius: 4px;
    }
    .province-name {
        width: calc(100% - 4px);
        position: relative;
        left: -13px;
    }
}
.search-img {
    width: 100%;
    height: 44px;
    background: #ffffff;
    border: 1px solid #e1e4eb;
    border-radius: 8px;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 24px;
    height: 44px;
    line-height: 44px;
    padding-right: 12px;
    img {
        width: 32px;
        height: 32px;
        float: right;
        cursor: pointer;
    }
    // input {
    //     background: #fff !important;
    // }
    // button {
    //     width: 100px;
    //     height: 44px;
    //     border: none !important;
    //     background: linear-gradient(270deg, $common-color, #60aaff 99%);
    //     border-radius: 8px;
    //     font-size: 18px;
    //     font-weight: 400;
    //     color: #ffffff;
    //     border: none;
    //     margin-left: 16px;
    //     position: relative;
    //     top: 1px;
    // }
}
.collapse-box {
    width: 100%;
    border-top: 1px solid #f0f2f5;
    font-size: 0;
    h2 {
        font-size: 22px;
        font-weight: 600;
        color: #332e2c;
        margin-top: 16px;
        height: 44px;
        line-height: 44px;
        background: linear-gradient(270deg, #ffffff, #fff3ee);
        border-radius: 8px;
        padding-left: 16px;
    }
    h4 {
        font-size: 18px;
        font-weight: 600;
        color: $common-color;
        padding-bottom: 18px;
        margin-bottom: 0;
        border-bottom: 1px solid #f0f2f5;
        margin-top: 18px;
        margin-left: 24px;
    }
    .occupation-list {
        margin-left: 24px;
        border-bottom: 1px solid #f0f2f5;
        padding-bottom: 20px;
    }
    .zytb-school-name {
        font-size: 16px;
        font-weight: 400;
        color: #2c2e33;
        margin-top: 20px;
        cursor: pointer;
    }
    .zytb-school-name:hover {
        color: $common-color;
    }
}
.zyb-box {
    background: none;
    border-radius: 0;
    box-shadow: none;
    position: relative;
    }
    .no-data-box {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: 80px;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
    }
}
.school-detail-nav {
    .el-tabs__item {
        position: relative;
        text-decoration:none;
        
    }
    .el-tabs__active-bar {
        // display: inline-block;
        // width: calc(100% - 40px);
        // margin-left: 20px;
        // position: absolute;
        // bottom: -10px;
        display: none;
    }
    .is-active span {
        display: inline-block;
         width: calc(100% - 40px);
        margin-left: 20px;
        position: absolute;
        bottom: -10px;
    }
}
</style>